import { IGoogleMap } from 'src/app/core/models/google-map-models';
import { IBoundingBoxModel } from 'src/app/core/models/models';

export class MarkerClusterService {

  readonly boundingBox = { bottom: 49.5, left: -10.6, right: 2, top: 61 };
  private delayZoomThreshold = 6;

  constructor() { }

  // public clearAllMarkers(markers: Array<any>) {
  //   markers.forEach(marker => {
  //     marker.setMap(null);
  //   });
  //   markers = [];
  // }

  public getBoundinBoxData(googleMap: IGoogleMap): IBoundingBoxModel {
    let boundingBoxObj: IBoundingBoxModel;

    if (googleMap.getZoom() >= this.delayZoomThreshold) {
      const curBounds = googleMap.getBounds();
      const sw = curBounds.getSouthWest();
      const ne = curBounds.getNorthEast();

      boundingBoxObj = { bottom: sw.lat(), left: sw.lng(), right: ne.lng(), top: ne.lat() };
    } else {
      boundingBoxObj = this.boundingBox;
    }
    return boundingBoxObj;
  }

}
